// <synth-panel> — a titled, bezeled section container with an accent strip.
//
// Usage: <synth-panel data-title="OSC 1" data-accent="1"> ...controls... </synth-panel>
// Children are kept (light DOM); the panel wraps them in a body element.

export class Panel extends HTMLElement {
  connectedCallback(): void {
    if (this.dataset.built) return;
    this.dataset.built = '1';

    const title = this.dataset.title ?? '';
    const accent = this.dataset.accent ?? '1';

    const header = document.createElement('div');
    header.className = 'panel-header';
    header.innerHTML = `<span class="panel-strip" data-accent="${accent}"></span><span class="panel-title">${title}</span>`;

    const body = document.createElement('div');
    body.className = 'panel-body';
    while (this.firstChild) body.appendChild(this.firstChild);

    this.classList.add('panel');
    this.appendChild(header);
    this.appendChild(body);
  }
}

customElements.define('synth-panel', Panel);
